module.exports = __webpack_public_path__ + "img/loading.fbfbe24b.gif";